<template>
  <div>
    <b-row class="row-fix">
      <b-col md="8" class="column full-height">
        <b-card v-if="event">
          <h3 class="capitalize">{{ event.data.date | moment("LLLL") }} - {{[event.data.end_time, "HH:mm:ss"] | moment("H:mm")}}</h3>
          <h4 v-if="event.data.theme">Thème : {{ event.data.theme }}</h4>
          <p v-if="event.data.description">{{ event.data.description }}</p>
          <div>Jeux annoncés</div>
          <GameList :boards="boards" @edit-board="editBoard($event)"/>
          <b-button class="newboard-button" variant="primary" v-if="isConnected" @click="addBoard()">Proposer un jeu</b-button>
        </b-card>

        <!-- Navigation buttons -->
        <div class="navigation-buttons">
          <b-button 
            v-if="previousEvent" 
            variant="outline-secondary" 
            class="prev-btn"
            @click="navigateToEvent(previousEvent.id)">
            <i class="fas fa-chevron-left"></i> Précédent
          </b-button>
          
          <b-button 
            v-if="nextEvent" 
            variant="outline-secondary" 
            class="next-btn"
            @click="navigateToEvent(nextEvent.id)">
            Suivant <i class="fas fa-chevron-right"></i>
          </b-button>
        </div>
    
      </b-col>
      <b-col md="4" class="column">
        <Location :location="event.location" v-if="event"/>
      </b-col>
    </b-row>
    
    <b-modal v-model="showModal" id="gameModal" title="Créer/modifier un jeu">
      <b-form >
        <b-form-group
          label="Nom :"
          label-for="nom">
          <b-form-input 
            id="nom"
            type="text"
            v-model="newBoard.name"
            required />
        </b-form-group>
        <b-form-group
          label="Joueurs minimum :"
          label-for="min_players">
          <b-form-input 
            id="min_players"
            type="number"
            v-model="newBoard.minPlayers"/>
        </b-form-group>
        <b-form-group
          label="Joueurs maximum :"
          label-for="max_players">
          <b-form-input 
            id="max_players"
            type="number"
            v-model="newBoard.maxPlayers"/>
        </b-form-group>
        <div v-if="newBoard.imagePath">
          <label>Icone</label><br>
          <img :src="backendUrl+'/game-images/'+newBoard.imagePath+'.jpg'" width="64" height="64" />
        </div>
        <b-form-group
          label="Image :"
          label-for="view"> 
          <b-form-file ref="file-input"
            v-model="newBoard.image"
            accept="image/*"
            placeholder="Choisissez une image..."></b-form-file>
        </b-form-group>
        
        <b-form-group
          label="Lien externe :"
          label-for="link"> 
          <b-form-input 
            id="link"
            type="text"
            placeholder="http://..."
            v-model="newBoard.external_link"/>
        </b-form-group>
        <b-button class="login-submit" type="button" v-if="!newBoard.id" variant="primary" @click="manageBoard()">Créer</b-button>
        <b-button class="login-submit" type="button" v-if="newBoard.id" variant="primary" @click="manageBoard()">Modifier</b-button>
        <b-button class="login-submit" type="button" v-if="newBoard.id" variant="error" @click="deletegame">Supprimer</b-button>
      </b-form>
      <div slot="modal-footer">
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import Location from '@/components/parts/Location'
import GameList from '@/components/parts/GameList'
export default {
  name: 'EventDetail',
  components: {
    Location,
    GameList,
  },
  data: function(){
    return {
      event: null,
      boards: [],
      showModal: false,
      newBoard: {},
      backendUrl: Vue.$backend.getBackendUrl(),
      nextEvent: null,
      previousEvent: null,
    }
  },
  computed:{
    isConnected: function(){
      return Vue.$isConnected()
    }
  },
  created: function(){
    this.loadEventData()
  },
  watch: {
    '$route'(to, from) {
      if (to.params.id !== from.params.id) {
        this.loadEventData()
      }
    }
  },
  methods: {
    loadEventData: function(){
      Vue.$backend.getEventDetails(this.$route.params.id).then(res => {
        this.event = res
        Vue.$backend.listFutureEvents().then(res => {
          this.allEvents = res
          const currentEventIndex = this.allEvents.findIndex(e => e.id === this.event.data.id)
          this.previousEvent = currentEventIndex > 0 ? this.allEvents[currentEventIndex - 1] : null
          this.nextEvent = currentEventIndex < this.allEvents.length - 1 ? this.allEvents[currentEventIndex + 1] : null
        })
      })
      Vue.$backend.getBoardsForEvent(this.$route.params.id).then(res => this.boards = res)
    },
    manageBoard: function(){
      if(this.newBoard.id){
        Vue.$backend.updateBoard(this.newBoard)
        .then(() => {
          this.showModal = false
          this.newBoard = {}
          this.$refs['file-input'].reset()
          Vue.$backend.getBoardsForEvent(this.$route.params.id).then(res => this.boards = res)
        })
      } else {
        Vue.$backend.createBoard(this.$route.params.id, this.newBoard)
        .then(() => {
          this.showModal = false
          this.newBoard = {}
          this.$refs['file-input'].reset()
          Vue.$backend.getBoardsForEvent(this.$route.params.id).then(res => this.boards = res)
        })
      }
    },
    deletegame: function(){
      Vue.$backend.deleteBoard(this.newBoard.id)
      .then(() => {
        this.showModal = false
        Vue.$backend.getBoardsForEvent(this.$route.params.id).then(res => this.boards = res)
      })
    },
    addBoard: function(){
      this.newBoard = {
          minPlayers: 2,
          maxPlayers: 4,
      }
      this.showModal = true
    },
    editBoard: function(board){
      this.newBoard = board
      board.image = null
      this.showModal = true
    },
    navigateToEvent: function(eventId){
      this.$router.push(`/evenement/${eventId}`)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.newboard-button{
  margin-top: 10px;
}

.navigation-buttons {
  margin-top: 10px;
  min-height: 35px;
}

.prev-btn {
  position: absolute;
  left: 20px;
}

.next-btn {
  position: absolute;
  right: 20px;
}

.full-height {
  min-height: 100%;
}

/* Responsive design for mobile */
@media (max-width: 768px) {
  .navigation-buttons {
    bottom: 10px;
  }
  
  .prev-btn {
    left: 10px;
    padding: 8px 16px;
    font-size: 0.9em;
  }
  
  .next-btn {
    right: 10px;
    padding: 8px 16px;
    font-size: 0.9em;
  }
}

</style>
